'use client';

import useSWR from 'swr';
import { externalAccountsApi } from '@/lib/api';
import type { DeclaredExternalAccount } from '@/types/onboarding';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useDeclaredExternalAccounts() {
  const authedFetch = useAuthedFetcher();

  return useSWR<DeclaredExternalAccount[]>(
    ['declared-external-accounts'],
    () => authedFetch((token) => externalAccountsApi.getAll(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
